import styled from 'styled-components';

export const Section = styled.section`
  padding: ${({ theme }) => theme.spacing.xxl} ${({ theme }) => theme.spacing.xl};
  background: #fafafa;
`;

export const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 300;
  letter-spacing: 2px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ theme }) => theme.spacing.xxl};
`;

export const SliderContainer = styled.div<{ $isDragging?: boolean }>`
  display: flex;
  gap: ${({ theme }) => theme.spacing.lg};
  overflow-x: auto;
  /* during drag: no smooth, no snap — instant feedback. After drag: snap kicks in */
  scroll-behavior: ${(p) => (p.$isDragging ? 'auto' : 'smooth')};
  scroll-snap-type: ${(p) => (p.$isDragging ? 'none' : 'x mandatory')};
  padding: ${({ theme}) => theme.spacing.md} 0;
  cursor: ${(p) => (p.$isDragging ? 'grabbing' : 'grab')};
  user-select: none;
  -webkit-user-drag: none;
  -webkit-overflow-scrolling: touch;

  & img {
    pointer-events: ${(p) => (p.$isDragging ? 'none' : 'auto')};
    -webkit-user-drag: none;
    user-select: none;
  }

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #657455;
    border-radius: 4px;
  }
`;

export const CardWrapper = styled.div`
  min-width: 300px;
  flex-shrink: 0;
  scroll-snap-align: start;
`;

export const WatchCard = styled.div`
  min-width: 300px;
  flex-shrink: 0;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  }
`;

export const WatchImageContainer = styled.div`
  width: 100%;
  height: 300px;
  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;

export const WatchImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;

  ${WatchCard}:hover & {
    transform: scale(1.05);
  }
`;

export const PlaceholderIcon = styled.div`
  font-size: 4rem;
  opacity: 0.3;
`;

export const WatchInfo = styled.div`
  padding: ${({ theme }) => theme.spacing.lg};
`;

export const WatchBrand = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #b8964a;
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  letter-spacing: 1px;
`;

export const WatchModel = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const WatchPrice = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  color: #b8964a;
`;

export const ViewAllCard = styled(WatchCard)`
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #b8964a 0%, #cdac63 100%);
  color: white;
  text-align: center;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  padding: ${({ theme }) => theme.spacing.xxl};
`;

export const ViewAllIcon = styled.div`
  font-size: 3rem;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const ViewAllText = styled.p`
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 1px;
`;
